module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/acceptance-approver/component/acceptance-approver/acceptance-approver.component.scss
// module id = ./src/app/acceptance-approver/component/acceptance-approver/acceptance-approver.component.scss
// module chunks = main